import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    adminMode: {
      namespaced: false,
      state: { isAdminMode: false },
      getters: {
        isAdminMode: (state: any) => state.isAdminMode,
      },
      mutations: {
        setAdminMode: (state: any, value: boolean) => {
          state.isAdminMode = value;
        },
      },
    },
  },
  strict: debug,
  plugins: [],
});
